export default function (value: string | null | Date) {
    const date = new Date(value || "now");
    return date.toLocaleDateString() + " " + date.toLocaleTimeString();
}
